/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Assigned_AgentInputs */

const cs_form_assigned_agent = /** @type {(inputs: Form_Assigned_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přiřazený makléř`)
};

const en_form_assigned_agent = /** @type {(inputs: Form_Assigned_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assigned agent`)
};

/**
* | output |
* | --- |
* | "Assigned agent" |
*
* @param {Form_Assigned_AgentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_assigned_agent = /** @type {((inputs?: Form_Assigned_AgentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Assigned_AgentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_assigned_agent(inputs)
	return cs_form_assigned_agent(inputs)
});